module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Regular.9139661.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nca/css/font/NotoSansKR-Regular.woff2
// module id = rNGR
// module chunks = 0